import Layout from 'antd/lib/layout';
import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import Text from 'antd/lib/typography/Text';
import { hexStringToRGBAString, runwayColors } from '../styles/globalStyles';
import { InstructionSteps } from '../RegisterDeviceInstructions';
import { useSelector } from 'react-redux';
import Alert from 'antd/lib/alert';
import { RootState } from '../../reducers/reducers';
import AuthedUrlButton from '../authedUrlButton/AuthedUrlButton';
import { PlusOutlined } from '@ant-design/icons';
import { selectAppName } from '../../selectors/selectors';
import { RunwayUserAction } from '@/helpers/aclHelpers';

export const RegisterTestDeviceInstructions: React.FC<AppComponentProps> = ({ appId, orgId }) => {
    const addDeviceEndpoint = `https://distro.runway.team/api/org/${orgId}/user/device/add?appId=${appId}`;

    const appName = useSelector((state: RootState) => selectAppName(state, appId));

    return (
        <Alert
            style={{
                padding: 16,
                borderColor: hexStringToRGBAString(runwayColors.primary, 0.25),
            }}
            description={
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 16,
                        width: '100%',
                    }}
                >
                    <Text strong style={{ textAlign: 'center', width: '100%' }}>
                        Registering a test device for {appName}
                    </Text>

                    <InstructionSteps>
                        <Text style={{ textAlign: 'center' }}>
                            Tap the ‘Register this device now’ button shown below.
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            The system will prompt you allow the download of a configuration profile. Tap ‘Allow’.
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            On this device, go to: <br />
                            <strong>Settings -{'>'} Profile Downloaded</strong>
                        </Text>
                        <Text style={{ textAlign: 'center' }}>
                            Tap ‘Install’ on the ‘Runway Build Distro’ profile.{' '}
                        </Text>
                    </InstructionSteps>

                    <AuthedUrlButton
                        type="primary"
                        actionType={RunwayUserAction.UAAddRemoveDeviceFromApp}
                        icon={<PlusOutlined />}
                        linkUrl={addDeviceEndpoint}
                        style={{
                            width: '100%',
                        }}
                        onLinkAuthed={(authedLink) => window.open(authedLink, '_self')}
                    >
                        Register this device now
                    </AuthedUrlButton>
                </div>
            }
            type="info"
        />
    );
};

export const MobileAddTestDevice: React.FC<AppComponentProps> = ({ appId, orgId }) => {
    return (
        <Layout
            style={{
                padding: 24,
                position: 'relative',
                overflow: 'scroll',
                height: '100%',
            }}
        >
            <RegisterTestDeviceInstructions appId={appId} orgId={orgId} />
        </Layout>
    );
};
